import Carousel from '../components/carousel';
import videos from '../config/videos';
import images from '../config/images';

const Home = () => {
  return (
    <Carousel videos={videos} images={images} />
  );
};

export default Home;
